export class Espectaculo {
  public id: number;
  public titulo: string;
  public subtitulo: string;
  public texto: string;
  public imagen_horizontal: string;
  public imagen_vertical: string;
  public fecha: string;
  public hora: string;
  public lugar: string;
  public destacado: boolean;
  public cartelera: number;
  public dia: string;
  public link: string;

  constructor() { }
}
